import { Box, Text, Button, Flex, Badge } from '@chakra-ui/react';
import { CalendarIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import * as routesNames from '../../../constants/routes'

interface Props {
    meeting: {
        meetingId: number;
        title: string;
        date: string;
        startTime: string;
        mode: string;
        meetingLink?: string;
        minutesLeft: number;
    };
    onDismiss: () => void;
}

const MeetingReminderPopup = ({ meeting, onDismiss }: Props) => {
    const navigate = useNavigate();
    return (
        <Box position="fixed" bottom="24px" right="24px" zIndex={9999} bg="white" borderRadius="12px" boxShadow="0 8px 32px rgba(0,0,0,0.18)" p={4} w="340px" borderLeft="4px solid #006838" animation="slideIn 0.3s ease" sx={{
            '@keyframes slideIn': { from: { transform: 'translateX(100%)', opacity: 0 }, to: { transform: 'translateX(0)', opacity: 1 } }
        }}
        >
            <Flex justify="space-between" align="flex-start" mb={2}>
                <Flex align="center" gap={2}>
                    <CalendarIcon color="green.600" />
                    <Text fontWeight="700" fontSize="sm" color="green.700">Meeting Reminder</Text>
                </Flex>
                <Button size="xs" variant="ghost" onClick={onDismiss} color="gray.400" _hover={{ color: 'gray.600' }} minW="auto" p={1} >
                    ✕
                </Button>
            </Flex>
            <Text fontWeight="600" fontSize="md" mb={1} noOfLines={2}>{meeting.title}</Text>
            <Flex align="center" gap={2} mb={3}>
                <Badge colorScheme="orange" borderRadius="full" px={2}>⏰ Starts in {meeting.minutesLeft} min</Badge>
                <Badge colorScheme={meeting.mode === 'Online' ? 'blue' : 'gray'} borderRadius="full" px={2}>{meeting.mode}</Badge>
            </Flex>

            <Text fontSize="xs" color="gray.500" mb={3}>🕐 {meeting.startTime}</Text>

            <Flex gap={2}>
                {meeting.mode === 'Online' && meeting.meetingLink && (
                    <Button size="sm" colorScheme="green" flex={1} onClick={() => { window.open(meeting.meetingLink, '_blank'); onDismiss(); }} >
                        Join Now
                    </Button>
                )}
                <Button size="sm" variant="outline" flex={1} onClick={() => { navigate(routesNames.MYMEETING); onDismiss(); }} >
                    View Meeting
                </Button>
                <Button size="sm" variant="ghost" color="gray.500" onClick={onDismiss} >
                    Dismiss
                </Button>
            </Flex>
        </Box>
    );
};

export default MeetingReminderPopup;  